"use client";

import { Link } from "@/components/common/Link";
export default function RecordedTeachings() {
  const courses = [{
    title: "2025 July Flowing Wisdom, Ripples of Insight",
    url: "https://sati.audiodharma.org/series/23365"
  }, {
    title: "2025 Feb The Dynamic Wheel of the Dharma",
    url: "https://sati.audiodharma.org/series/22365"
  }, {
    title: "2024 January CRAFT-ing our path",
    url: "https://www.audiodharma.org/series/10094"
  }, {
    title: "2024 July Entering the World of the Pali Canon",
    url: "https://www.audiodharma.org/series/2345"
  }, {
    title: "2023 December Fear, Dread and Freedom",
    url: "https://www.audiodharma.org/series/9456"
  }, {
    title: "2023 April Getting to the Heart of Practice",
    url: "https://www.audiodharma.org/series/8723"
  }, {
    title: "2023 January The Path to True Wealth and Security",
    url: "https://www.audiodharma.org/series/7891"
  }, {
    title: "2022 August Pride and Prejudice: A Theatrical Presentation and Discussion of DN 3 The Ambattha Sutta",
    url: "https://www.audiodharma.org/series/7234"
  }, {
    title: "2022 January Embodiment and Enlightenment ",
    url: "https://www.audiodharma.org/series/6789"
  }, {
    title: "2021 August Awakening Poems",
    url: "https://www.audiodharma.org/series/6234"
  }, {
    title: "2021 July Entering the World of the Pali Canon",
    url: "https://sati.audiodharma.org/series/13890"
  }, {
    title: "2021 April The simile of the snake MN 22",
    url: "https://www.audiodharma.org/series/5123"
  }, {
    title: "2021 January Mahaparinibbana Sutta",
    url: "https://www.audiodharma.org/series/4567"
  }, {
    title: "2020 Equanimity",
    url: "https://sati.audiodharma.org/series/12586"
  }, {
    title: "2020 Kalayanamitta",
    url: "https://sati.audiodharma.org/series/10946"
  }, {
    title: "2019 Anapanaya",
    url: "https://www.audiodharma.org/series/10094"
  }];
  return <section className="bg-[hsl(40,25%,94%)] py-20 px-4 sm:px-6 lg:px-8">
      <div className="mx-auto max-w-7xl">
        <div className="mb-12 text-center pt-4">
          <h2 className="font-display text-4xl font-bold text-foreground sm:text-5xl mb-6">
            Recorded Course Series
          </h2>
          <p className="text-base text-muted-foreground max-w-2xl mx-auto italic">
            "One learns the Dhamma… Having learned the Dhamma, one examines it… and
            realizes the truth." MN 95 Cankī Sutta.
          </p>
        </div>

        <div className="mb-12 max-w-3xl mx-auto">
          <div className="grid gap-4 sm:grid-cols-2">
            {courses.map((course, i) => <Link key={i} to={course.url} data-index={i} className="block bg-[hsl(45,40%,85%)] rounded-lg shadow-[0_2px_8px_rgba(0,0,0,0.04),0_1px_3px_rgba(0,0,0,0.08)] p-6 transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] hover:-translate-y-1 hover:shadow-[0_4px_16px_rgba(0,0,0,0.12),0_2px_6px_rgba(0,0,0,0.08)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring">
                <h4 className="font-display text-lg font-semibold text-foreground group-hover:text-gray-900 transition-colors">
                  {course.title}
                </h4>
                <p className="mt-2 text-sm text-muted-foreground">
                  Listen to the full series →
                </p>
              </Link>)}
          </div>
        </div>

        <div className="text-center py-12">
          <p className="text-lg text-foreground font-semibold">
            <Link to="https://www.audiodharma.org/" className="text-primary hover:text-gray-900 underline transition-colors duration-200">
              Find these teachers' teachings here
            </Link>
          </p>
        </div>
      </div>
    </section>;
}